// Lib
import { keyBy } from 'lodash/fp';

// Utils
import mergePointerGroups from './mergePointerGroups';
import findPointerGroups from './findPointerGroups';

export default ({ pointers, layerRect }) => {
    const pointersMap = keyBy('id', pointers);

    const groups = findPointerGroups({ pointers, layerRect });

    return mergePointerGroups({ groups, pointersMap });
};
